/* Az Bilinenler: little-known facts about the guitar and the voice, each explained with its reason, made
   audible and visible with lesson blocks. Every fact cites at least two independent sources in an English
   comment right above it (facts.test.ts checks this); a claim that can't be verified stays out. */
import { gitar } from './gitar';
import type { Fact, FactTopic } from './types';
import { vokal } from './vokal';

export type { Fact, FactTopic };

/** Route id of the corner; a fact lives at `${FACTS_ROUTE}.${id}`. */
export const FACTS_ROUTE = 'az-bilinenler';

export const FACTS: Fact[] = [...gitar, ...vokal];

export const TOPIC_NAME: Record<FactTopic, string> = { gitar: 'Gitar', vokal: 'Vokal' };

export const factById = (id: string): Fact | undefined => FACTS.find((f) => f.id === id);

export const factRoute = (f: Fact): string => `${FACTS_ROUTE}.${f.id}`;

/** The fact shown on the home page: a different one each day, the same all day. */
export function factOfDay(date: Date = new Date()): Fact {
  const day = Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86_400_000);
  return FACTS[day % FACTS.length] as Fact;
}
